import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
  })
export class ConfirmationDialogComponent {
    title: string;
    message: string;
    confirmationCallback: CallableFunction;

    constructor(private activeModal: NgbActiveModal) {}

    closeModal(isConfirmed: boolean): void {
      this.activeModal.close();
      if (isConfirmed) {
        this.confirmationCallback();
      }
  }
}  